import { AccountType } from '../service-proxies';


export class AccountBalanceDto implements IAccountBalanceDto {
    id!: number;
    accountName!: string | undefined;
    accountType!: AccountType;
    currentBalance!: number;

    constructor(data?: IAccountBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.accountType = _data["accountType"];
            this.currentBalance = _data["currentBalance"];
        }
    }

    static fromJS(data: any): AccountBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["accountType"] = this.accountType;
        data["currentBalance"] = this.currentBalance;
        return data; 
    }
}

export interface IAccountBalanceDto {
    id: number;
    accountName: string | undefined;
    accountType: AccountType;
    currentBalance: number;
}

